import { ListingsSearchSideFilters } from '../types';

import { getEmptyListingsSearchAllFilters } from './getEmptyListingsSearchAllFilters';
import { mapListingsSearchAllFiltersToSideFilters } from './mapListingsSearchAllFiltersToSideFilters';

export function getEmptyListingsSearchSideFilters(): ListingsSearchSideFilters {
  const allFilters = getEmptyListingsSearchAllFilters();
  return mapListingsSearchAllFiltersToSideFilters(allFilters);
}
